import Vue from 'vue'
import App from './App.vue'

import 'babel-polyfill'
import router from './router/router.js' // 把 /router 下所有 router配置 都导入
import api from './api'  //相当于引入index.js中导出的api接口

// 导入 element-ui 和 其css
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icon/iconfont.css';
// 导入 axios
import axios from 'axios';
import VueAxios from 'vue-axios';
//import { createProxyMiddleware } from 'http-proxy-middleware';
import Print from '@/plugs/print'

import FooterView from '@/components/common/FooterView'
import HeaderView from '@/components/common/HeaderView'
import NavigateView from '@/components/common/NavigateView'
import BannerView from '@/components/common/BannerView'
/* 尽量少用 cnpm : 因为可能安装失败 */

import JsEncrypt from 'jsencrypt/bin/jsencrypt';
import md5 from 'js-md5';
import AES from "@/utils/AES.js";
let base64 = require('js-base64').Base64;

Vue.use(router);
Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.use(Print) // 注册
//如果这配置 'api/'会默认读取本地的域
//axios.defaults.baseURL = apiConfig.baseUrl;
//密码非对称加密
Vue.prototype.$jsEncrypt = JsEncrypt;
Vue.prototype.$md5 = md5;
Vue.prototype.$base64 = base64;
Vue.prototype.$AES = AES;

Vue.prototype.$api = api;  // 将api挂载到vue的原型上
Vue.component("FooterView", FooterView);
Vue.component("HeaderView", HeaderView);
Vue.component("NavigateView", NavigateView);
Vue.component("BannerView", BannerView);
new Vue({
  el: '#app',
  router,  // <--- 导入 router.js
  render: h => h(App),  // ElementUI
    // render v. 提供,提取

  components: { App },
  template: '<App/>'
})

/*
一定报错： Login.vue 的错误

实际上是：
  packson.json 的 sass-loader 版本太高
 */



// WEBPACK FOOTER //
// ./src/main.js